import React from 'react';
import ColorInput from './ColorInput';
import NumberInput from './NumberInput';
import StyledButton from './StyledButton'; // Adjust the import path as needed

const ConfigSection = ({ title, inputs }) => (
  <div className="config-section">
    <h4>{title}</h4>
    {inputs?.map((input, index) => {
      if (input.type === 'color') {
        return (
          <ColorInput
            key={index}
            label={input.label}
            name={input.name}
            value={input.value}
            onChange={input.onChange}
          />
        );
      } else if (input.type === 'number') {
        return (
          <NumberInput
            key={index}
            label={input.label}
            name={input.name}
            value={input.value}
            onChange={input.onChange}
          />
        );
      } else if (input.type === 'button') {
        return (
          <StyledButton key={index} onClick={input.onClick}>
            {input.label}
          </StyledButton>
        );
      }

      return null;
    })}
  </div>
);

export default ConfigSection;
